import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import * as labelConfigs from '../../configs/labelConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_CLIENT_REFRESH,LOGIN_SUPER_ADMIN_GROUP,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,ROUTE_AFFILIATE_SHIFT,ROUTE_AFFILIATE_CREW,ROUTE_AFFILIATE_FEEDBACK,ROUTE_AFFILIATE_TIMESHEET,ROUTE_AFFILIATE_DASHBOARD, ROUTE_AFFILIATE_CERTIFICATES, ROUTE_AFFILIATE_QUOTES, ROUTE_AFFILIATE_EVENTS, ROUTE_DASHBOARD, ROUTE_QUOTES, ROUTE_CLIENT_DASHBOARD,ROUTE_CLIENT_QUOTES,ROUTE_CLIENT_EVENTS,ROUTE_CLIENT_TIMESHEET,ROUTE_CLIENT_FEEDBACK} from '../../configs/staticConfigs';
import { getStorage, setStorage } from '../../utils/browserStorage';  

import {FCM_NOTIFICATION_SEND_SUCCESS,FCM_NOTIFICATION_SEND_ERROR,FCM_NOTIFI_TOKEN_SAVE_SUCCESS,FCM_NOTIFI_TOKEN_SAVE_ERROR} from '../../actions';    

import {converDateToLocal} from '../../utils/commonUtilities';
import {fcmNotifiTokenSaveAction,fcmNotificationSendAction} from '../../actions/fcmActions';  
import {crewUnapprovedCountAction} from '../../actions/crewActions';  
import {getActionRequiredData,chartData,getClientActionRequiredData,clientChartData,shiftTimeChangeRequestCountAction} from '../../actions/dashboardActions';
import {fromDashboardShiftTimeChange,clearAction, fromDashboard, fromActionRequired,fromClientDashboardQuotes,fromClientDashboardEvents,fromClientDashboardCompletedEvents} from '../../actions/commonActions';
import * as types from '../../actions';
import { Redirect,Link } from 'react-router-dom';
import { format } from 'date-fns';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { Chart } from "react-google-charts";


class DashBoardComponent extends Component {


    constructor(props){
        super(props)

        this.state = {
            userGroupId : '', 
            fcmNotifiTokenLoaded: 0,
            shiftChangeRequested:0,
            unallocatedShifts:0,
            expiringCertificates:0,
            negativeFeedbacks:0,
            overTimeRequests:0,
            quoteRequested:{new_requests:0,existing_requests:0},
            quoteRequestData:[],
            activeEventData:[],
            shiftData:[],
            startDate:'',
            endDate:'',
            days:'last_30',
            disableDate:true,
            formErrors:{'startDate':false,'endDate':false},
            dateType:'created_date',
            strStartDate:'',
            strEndDate:'',
            newEvents:0,
            activeEvents:0,
            otRequests:0,
            clientFeedbacks:0,
            completedEvents:0,
            shiftTimeChangeRequestCount: 0,
        }
    }

    setStateUpdate(activity,errorData,actionRequiredItems,clientActionRequiredItems,dashboardChartData, dashboardClientChartData,shiftTimeChangeRequestCountData){
      if(activity===types.DASHBOARD_ACTION_REQUIRED_LIST_SUCCESS){
            const {quoteRequested,unallocatedShifts,expiringCertificates,negativeFeedbacks,overTimeRequests} = this.state;
            this.setState({shiftChangeRequested: actionRequiredItems.shift_request_count,
                            unallocatedShifts: actionRequiredItems.unallocated_shift_count,
                            expiringCertificates: actionRequiredItems.expiring_certificates,
                            negativeFeedbacks: actionRequiredItems.feedback_count,
                            overTimeRequests: actionRequiredItems.OT_count,
                            quoteRequested: actionRequiredItems.quote_requested
                        }); 
      }else if(activity===types.DASHBOARD_CHART_DATA_LIST_SUCCESS){
            const {quoteRequestData,activeEventData,shiftData} = this.state;
            this.setState({quoteRequestData: dashboardChartData.quote_request_data,
                            activeEventData: dashboardChartData.active_event_data,
                            shiftData: dashboardChartData.shift_data
                        });

      }else if(activity===types.DASHBOARD_CLIENT_ACTION_REQUIRED_LIST_SUCCESS){
        const {newEvents,activeEvents,otRequests,clientFeedbacks} = this.state;
        this.setState({newEvents: clientActionRequiredItems.new_events,
                        activeEvents: clientActionRequiredItems.active_events,
                        otRequests: clientActionRequiredItems.overtime_requests,
                        clientFeedbacks: clientActionRequiredItems.feedbacks,
                        completedEvents: clientActionRequiredItems.completed_events
                    });

      }else if(activity===types.DASHBOARD_CLIENT_CHART_DATA_LIST_SUCCESS){
            const {quoteRequestData,activeEventData,shiftData} = this.state;
            this.setState({quoteRequestData: dashboardClientChartData.quote_request_data,
                            activeEventData: dashboardClientChartData.active_event_data
                        });
      }else if(activity===types.SHIFT_TIME_CHANGE_REQUEST_COUNT_SUCCESS){
        let shiftTimeChangeRequestCount = shiftTimeChangeRequestCountData.time_change_count;
        this.setState({shiftTimeChangeRequestCount}); 
      }
      else if(activity===types.SHIFT_TIME_CHANGE_REQUEST_COUNT_ERROR){
        this.setState({shiftTimeChangeRequestCount:0}); 
      }
  }

    goToClientProfile(e, page) {
        let route_url = '';
        if(page==="shift"){
            route_url = ROUTE_AFFILIATE_SHIFT;
            this.props.fromDashboard(true);
        }else if(page==="crew"){
            route_url = ROUTE_AFFILIATE_CERTIFICATES;
        }else if(page==="feedback"){
            route_url = ROUTE_AFFILIATE_FEEDBACK;
            this.props.fromDashboard(true);
        }else if(page==="timesheet"){
            route_url = ROUTE_AFFILIATE_TIMESHEET;
        }else if(page==="new_quote"){
            route_url = ROUTE_AFFILIATE_QUOTES;
            this.props.fromActionRequired(true);
        }else if(page==="existing_quote"){
            route_url = ROUTE_AFFILIATE_EVENTS;
            this.props.fromActionRequired(true);
        }else if(page==="client_new_events"){
            route_url = ROUTE_CLIENT_QUOTES;
            this.props.fromClientDashboardQuotes(true);
        }else if(page==="client_active_events"){
            route_url = ROUTE_CLIENT_EVENTS;
            this.props.fromClientDashboardEvents(true);
        }else if(page==="client_ot_requests"){
            route_url = ROUTE_CLIENT_TIMESHEET;
        }else if(page==="client_feedbacks"){
            route_url = ROUTE_CLIENT_FEEDBACK;
        }else if(page==="client_completed_events"){
            route_url = ROUTE_CLIENT_EVENTS;
            this.props.fromClientDashboardCompletedEvents(true);
        } else if(page==="shift_time_change"){
          route_url = ROUTE_AFFILIATE_EVENTS;
          this.props.fromDashboardShiftTimeChange(true);
        }

      this.props.history.push(route_url);
   }

   onDaysChange= (e, group) =>{
        const value = e.target.value;
        let {startDate,endDate,dateType,days,strEndDate,strStartDate,disableDate} = this.state;
        if(value === 'Other'){
            disableDate = false;
            days = value;
        }else{
            disableDate = true;
            startDate = '';
            strStartDate = '';
            endDate = '';
            strEndDate = '';
            days = value;
            let data = {'dateType':dateType,'days':days,'fromDate':'','toDate':''};
            if(group == 'affiliate'){
                this.props.chartData(data);
            }else if(group == 'client'){
                this.props.clientChartData(data);
            }
        }
        
        this.setState({ days: days,
                        disableDate: disableDate,
                        startDate:startDate,
                        endDate:endDate,
                        strStartDate:strStartDate,
                        strEndDate:strEndDate
                        });
   }

   onStartDateChange = (date,group) =>{
        let {startDate,dateType,days,strEndDate,strStartDate} = this.state;
        if(date==='' || date===null){
            startDate = new Date();
            strStartDate = format(new Date(), 'yyyy-MM-dd');
        }else{
            startDate = new Date(date);
            strStartDate = format(new Date(startDate), 'yyyy-MM-dd');
        }

        let data = {'dateType':dateType,'days':days,'fromDate':strStartDate,'toDate':strEndDate};
        if(strStartDate && strEndDate){
            if(group == 'affiliate'){
                this.props.chartData(data);
            }
            else if(group == 'client'){
                this.props.clientChartData(data);
            }
        }
        this.setState({startDate:startDate,strStartDate:strStartDate});
   }

   onEndDateChange = (date, group) =>{
        let {startDate,endDate,dateType,days,strEndDate,strStartDate} = this.state;
        if(date==='' || date===null){
            endDate = new Date();
            strEndDate = format(new Date(), 'yyyy-MM-dd');
        }else{
            endDate = new Date(date);
            strEndDate = format(new Date(endDate), 'yyyy-MM-dd');
        }
        let data = {'dateType':dateType,'days':days,'fromDate':strStartDate,'toDate':strEndDate};
        if(strStartDate && strEndDate){
            if(group == 'affiliate'){
                this.props.chartData(data);
            }
            else if(group == 'client'){
                this.props.clientChartData(data);
            }
        }
        this.setState({endDate:endDate,strEndDate:strEndDate});      
    }

    onDateTypeChange = (e, group) =>{
        let {startDate,endDate,dateType,days,strEndDate,strStartDate} = this.state;
        dateType = e.target.value;
        let data = {'dateType':dateType,'days':days,'fromDate':strStartDate,'toDate':strEndDate};
        if(days!=='Other' || (strStartDate && strEndDate)){
            if(group == 'affiliate'){
                this.props.chartData(data);
            }
            else if(group == 'client'){
                this.props.clientChartData(data);
            }
        }
        this.setState({dateType:dateType});

    }

    redirectToQuote = (e,group) =>{
        this.props.fromDashboard(true);
        if(group=='affiliate')
        this.props.history.push(ROUTE_AFFILIATE_QUOTES);
        else if(group=='client')
        this.props.history.push(ROUTE_CLIENT_QUOTES);
    }
    onShowAllUnapprovedCrews = () =>{
        this.props.fromDashboard(true);
        this.props.history.push(ROUTE_AFFILIATE_CREW);
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        
        if(!userGroupData.fcm_notifi_token_sent) {
            let fcmToken = getStorage('fcmNotificationToken');
            // console.log('Tokeln Not Sent '+fcmToken); 
            var fingerprint = require('browser-fingerprint')()
            let dataObj = {"token": fcmToken, "device_type": 1, "fingerprint":fingerprint}; 
            // console.log('dataObj: '+JSON.stringify(dataObj)); 
            this.props.fcmNotifiTokenSaveAction(dataObj);  
            // fcm_notifi_token fcm_notifi_token_sent  
        }

        this.setState({userGroupId: userGroup}); 
        document.title = labelConfigs.LBL_APP_NAME+' : Dashboard';
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
        }
        const { location } = this.props;
        if (location.pathname === ROUTE_AFFILIATE_DASHBOARD){
            let data = {'dateType':'created_date','days':'last_30','fromDate':'','toDate':''};
            this.props.getActionRequiredData();
            this.props.chartData(data);
            this.props.shiftTimeChangeRequestCountAction(); 
        }else if(location.pathname === ROUTE_CLIENT_DASHBOARD){
            let data = {'dateType':'created_date','days':'last_30','fromDate':'','toDate':''};
            this.props.getClientActionRequiredData();
            this.props.clientChartData(data);
        }
        
        setTimeout(()=> {
            this.setState({fcmNotifiTokenLoaded:1});
        }, 3000);
        this.props.crewUnapprovedCountAction();
    }

    componentDidUpdate(prevProps) { 
        const {isFilterOn,activity,errorData,actionRequiredItems,clientActionRequiredItems,dashboardChartData, dashboardClientChartData, shiftTimeChangeRequestCountData} = this.props;
        if (isFilterOn !== prevProps.isFilterOn) {
            this.inputFilter.click();   
        }else if (activity && activity !== prevProps.activity) {
             this.setStateUpdate(activity.split('~~')[0],errorData,actionRequiredItems,clientActionRequiredItems,dashboardChartData, dashboardClientChartData,shiftTimeChangeRequestCountData);
             this.props.clearAction();
        }
        const { fcmNotifiTokenSaveStatus, fcmNotifiTokenSaveActivity,fcmNotificationSendErrorData } = this.props; 
        if ((fcmNotifiTokenSaveStatus !== prevProps.fcmNotifiTokenSaveStatus || fcmNotifiTokenSaveActivity !== prevProps.fcmNotifiTokenSaveActivity)) { 
            if(fcmNotifiTokenSaveStatus===200 && fcmNotifiTokenSaveActivity===FCM_NOTIFI_TOKEN_SAVE_SUCCESS) {  
                
                let userGroupData = userGroupUrlCheck(this.props.location);
                let userGroup = ''; 
                userGroupData.fcm_notifi_token_sent = 1; 
                userGroupData.fcm_notifi_token = getStorage('fcmNotificationToken');
                if(userGroupData!==undefined){
                    userGroup = userGroupData.user_group; 
                    if(userGroup===LOGIN_SUPER_ADMIN_GROUP){
                        setStorage('super', JSON.stringify(userGroupData));
                    }else if(userGroup===LOGIN_AFFILIATE_GROUP){
                        setStorage('affiliate', JSON.stringify(userGroupData));
                    }else if(userGroup===LOGIN_CLIENT_GROUP){ 
                        setStorage('client', JSON.stringify(userGroupData));
                    }
                    //console.log('userGroupData ', JSON.stringify(userGroupData)); 
                }
                // let dataObj = {"registration_ids":[userGroupData.user_id]}; 
                // this.props.fcmNotificationSendAction(dataObj); 
            }
            else if(fcmNotifiTokenSaveStatus!==200 || fcmNotifiTokenSaveActivity===FCM_NOTIFI_TOKEN_SAVE_ERROR){  
            }
        }
    }

    render(){

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group;
        } 
        // if (!this.state.fcmNotifiTokenLoaded) {
        //     return <div />
        // }
        const { location, status } = this.props;
        const {quoteRequested,unallocatedShifts,expiringCertificates,negativeFeedbacks,overTimeRequests,quoteRequestData,activeEventData,
            shiftData,disableDate,startDate,endDate,formErrors,newEvents,
            activeEvents,
            otRequests,
            clientFeedbacks,completedEvents } = this.state;
        let selectedStartDate = startDate;
        let selectedEndDate = endDate;

        let currentDate = new Date();
        let timeZone =  getUserTimeZone(location);
        let strDatetime = format(currentDate, 'yyyy-MM-dd HH:mm:ss');
        // let convertedDate = converDateToLocal(strDatetime,timeZone.utc_offset,'dateObj','-'); 
        let convertedDate = converDateToLocal(currentDate,timeZone.utc_offset,'dateObj','-');
        let startfrom = new Date(convertedDate);
        startfrom = startfrom.setDate(startfrom.getDate() - 1);
        startfrom= format(startfrom,'dd/MM/yyyy');
        let endTo = convertedDate.setDate(convertedDate.getDate() +30); 
        endTo = format(endTo,'dd/MM/yyyy');
        
        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else if(userGroup===LOGIN_CLIENT_GROUP){
                return <Redirect to={ROUTE_CLIENT_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;
            }
        }

        if(location.pathname==ROUTE_DASHBOARD && userGroup===LOGIN_SUPER_ADMIN_GROUP){
            return <Redirect to={ROUTE_QUOTES} />;
        }

        // console.log(shiftData);
        // console.log(quoteRequestData);
        // console.log(activeEventData);
        if (location.pathname!==ROUTE_AFFILIATE_DASHBOARD)
            return(
            <React.Fragment>
                <div className="dashboard dash_width">
                    <div className="container">
                        <div className="dash-row stories">
                            <div className="client-dash-col3">
                                <div className="card" >
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="col">                  
                                   
                                          <p className="h6 p_text_color mb-2">{labelConfigs.LBL_EVENTS}</p> 
                                           <div className="div-margin-positive"><small className="p_text_color"></small></div>        
                                              <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{ show: 450, hide: 250 }}
                                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                        opacity: 0.4,
                                                      }}>
                                                    Quotes
                                                  </Tooltip>}
                                                > 
                                                   <span className="h2 mb-0 text-red href-link" onClick={(e) => this.goToClientProfile(e,"client_new_events")}>
                                                {newEvents}
                                                </span>
                                                   
                                                </OverlayTrigger>  
                                                                
                                                
                                                <span className="h2 mb-0 text-black"> : </span>

                                                <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{ show: 450, hide: 250 }}
                                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                        opacity: 0.4,
                                                      }}>
                                                    Active {labelConfigs.LBL_EVENTS}
                                                  </Tooltip>}
                                                > 
                                                   <span className="h2 mb-0 text-red href-link" onClick={(e) => this.goToClientProfile(e,"client_active_events")}>{activeEvents}</span>
                                                   
                                                </OverlayTrigger>  
                                                            
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info BlueRibbon"><i className="fas fa-calendar-week"></i></span>
                                      </div>
                                    </div>
                                  </div>
                           
                                </div>
                            </div>
                            <div className="client-dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"client_completed_events")}>
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="col">                  
                                          
                                          <p className="h6 p_text_color mb-2">Completed {labelConfigs.LBL_EVENTS}</p>                  
                                          <div className="div-margin-positive"><small className="p_text_color"></small></div>
                                          <span className="h2 mb-0">
                                            {completedEvents}
                                          </span>
                                                            
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info OceanGreen"><i className="fas fa-calendar-check"></i></span>
                                      </div> 
                                    </div>
                                  </div>                           
                                </div>

                            </div>
                            <div className="client-dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"client_ot_requests")}>
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="col">                  
                                     
                                          <p className="h6 mb-2 p_text_color">OT/OE Requests</p>                  
                                          <div className="div-margin-positive"><small className="p_text_color"></small></div>
                                          <span className="h2 mb-0">
                                            {otRequests}
                                          </span>
                                                            
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info Mandy"><i className="fas fa-stopwatch"></i></span>
                                      </div>
                                    </div>
                                  </div>                           
                                </div>
                            </div>
                            <div className="client-dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"client_feedbacks")}>
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="col">                  
                                          <p className="h6 mb-2 p_text_color">Feedback</p>
                                          <div className="div-margin-positive"><small className="p_text_color"></small></div>                  
                                          <span className="h2 mb-0">
                                            {clientFeedbacks}
                                          </span>
                                                            
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info PurpleHeart"><i className="fas fa-comment-slash"></i></span>
                                      </div> 
                                    </div>
                                  </div>                           
                                </div>
                                
                            </div>
                        </div>
                        <div className="dash-row action mt-2">
                            <div className="col-3 col-lg-4">
                            </div>
                            <div className={disableDate?"col-3 col-lg-2 mr-0":'hide'}>
                            </div>
                            <div className={disableDate?"col-3 col-lg-2 mr-0":'hide'}>
                            </div>
                            <div className="col-3 col-lg-2 mr-0">
                                <div className="form-group select-input bg-white">
                                    <select className="" aria-placeholder="Select" onChange={e => this.onDateTypeChange(e,'client')}>
                                        <option value="created_date">Created Date</option>
                                        <option value="event_date">{labelConfigs.LBL_EVENT} Date</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-3 col-lg-2 mr-0">
                                <div className="form-group select-input bg-white">
                                    <select className="" aria-placeholder="Select" onChange={e => this.onDaysChange(e,'client')}>
                                        <option value="last_30">Last 30 days</option>
                                        <option value="next_30">Next 30 days</option>
                                        <option value="last_60">Last 60 days</option>
                                        <option value="next_60">Next 60 days</option>
                                        <option value="last_90">Last 90 days</option>
                                        <option value="next_90">Next 90 days</option>
                                        <option value="last_120">Last 120 days</option>
                                        <option value="next_120">Next 120 days</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                            <div className={disableDate?'hide':"col-3 col-lg-2 mr-0"}>
                                <div className="form-group">
                                    <div className={disableDate?'text-optional calendar-input':'calendar-input background-white'}>
                                        <DatePicker 
                                            onChange={selected =>this.onStartDateChange(selected,'client')}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Start Date"
                                            fixedHeight          
                                            className={formErrors.startDate ? "input-error" : ''}
                                            disabled={disableDate}
                                            selected={selectedStartDate}
                                            placeHolderTextStyle={{ color: '#d3d3d3' }}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={disableDate?'hide':"col-3 col-lg-2 mr-0"}>
                                <div className="form-group">
                                    <div className={disableDate?'text-optional calendar-input':'calendar-input background-white'}>
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                minDate={startDate}
                                                fixedHeight       
                                                disabled={disableDate}
                                                onChange={selected =>this.onEndDateChange(selected, 'client')}                       
                                            />
                                    </div>
                                </div>
                            </div>      
                        </div>
                        <div className="dash-row mt-2">
                            <div className="col-6">
                                <div className="dashbox">
                                    <div className="box-head">
                                            <h6 className="m-0 divFloatLeft">Quote Summary</h6>
                                            <p className="h6 text-muted right-align marginBottomO"><Link onMouseDown={e => this.redirectToQuote(e,'client')} to="#">+ New Quote</Link></p>
                                        
                                    </div>
                                        <div className="chart" id={"pieChart"}>
                                          <Chart
                                              width={'100%'}
                                              height={'40vh'}
                                              chartType="PieChart"
                                              loader={<div>Loading Chart</div>}
                                              messages={{empty: "No data"}}
                                              data={quoteRequestData}
                                                options={{
                                                  legend: {
                                                        position: 'right',
                                                        alignment: "top",
                                                        textStyle: {
                                                          color: "233238",
                                                          fontSize: 14
                                                        }
                                                      },
                                                  pieSliceText: 'label',
                                                  title: '',
                                                  pieStartAngle: 100,
                                                  slices: [
                                                            {
                                                              color: "#6b1c68"
                                                            },
                                                            {
                                                              color: "#0e6f69"
                                                            },
                                                            {
                                                              color: "#0895c4"
                                                            },
                                                            {
                                                              color: "#003B5C"
                                                            },
                                                            {
                                                              color: "#d53554"
                                                            },
                                                            {
                                                              color: "#51104e"
                                                            },
                                                            {
                                                              color: "#dc724c"
                                                            }
                                                          ]
                                                }}
                                                rootProps={{ 'data-testid': '4' }}


                                          />
                                        </div>
                                </div>                         
                            </div>
                            <div className="col-6">
                                <div className="dashbox">
                                    <div className="box-head">
                                        <h6 className="m-0">{labelConfigs.LBL_EVENT} Summary</h6>
                                    </div>
                                        <div className="chart" id={"pieChart"}>
                                          <Chart
                                              width={'100%'}
                                              height={'40vh'}
                                              chartType="PieChart"
                                              loader={<div>Loading Chart</div>}
                                              data={activeEventData}
                                                options={{
                                                  pieHole: 0.4,
                                                  legend: {
                                                        position: "right",
                                                        alignment: "top",
                                                        textStyle: {
                                                          color: "233238",
                                                          fontSize: 14
                                                        }
                                                      },
                                                  pieSliceText: 'label',
                                                  title: '',
                                                  pieStartAngle: 100,
                                                  slices: [
                                                            {
                                                              color: "#6b1c68"
                                                            },
                                                            {
                                                              color: "#0e6f69"
                                                            },
                                                            {
                                                              color: "#0895c4"
                                                            },
                                                            {
                                                              color: "#003B5C"
                                                            },
                                                            {
                                                              color: "#d53554"
                                                            },
                                                            {
                                                              color: "#58b67c"
                                                            },
                                                            {
                                                              color: "#999"
                                                            },
                                                            {
                                                              color: "#dc724c"
                                                            },
                                                            {
                                                              color: "#51104e"
                                                            }
                                                          ]
                                                }}
                                                rootProps={{ 'data-testid': '4' }}


                                          />
                                        </div>                   
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
               

            </React.Fragment>    
        )

        return(
            <React.Fragment>
               <div className="dashboard dash_width">
                    <div className="container">

                        <div className="dash-row stories margin-left-10">
                            <div className="dash-col3">
                                <div className="card ">
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-number">
                                          <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 450, hide: 250 }}
                                                overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                    opacity: 0.4,
                                                  }}>
                                                {labelConfigs.LBL_NEW_QUOTE_REQUESTS}
                                              </Tooltip>}
                                            > 
                                               <span className="h2 mb-0 text-red href-link" onClick={(e) => this.goToClientProfile(e,"new_quote")}>
                                            {quoteRequested?quoteRequested.new_requests:0}
                                            </span>
                                            </OverlayTrigger>
                                            <span className="h2 mb-0 text-black"> : </span>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 450, hide: 250 }}
                                                overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                    opacity: 0.4,
                                                  }}>
                                                {labelConfigs.LBL_EXISTING_QUOTE_REQUESTS}
                                              </Tooltip>}
                                            > 
                                               <span className="h2 mb-0 text-red href-link" onClick={(e) => this.goToClientProfile(e,"existing_quote")}>{quoteRequested?quoteRequested.existing_requests:0}</span>
                                            </OverlayTrigger>
                                        </div>

                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div>
                                                {labelConfigs.LBL_QUOTE_REQUESTS}
                                                <div><small className="p_text_color">({labelConfigs.LBL_NEW_AND_EXISTING})</small></div>
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info RedViolet"><i className="fas fa-exchange-alt"></i></span>
                                        </div> 
                                        
                                        {/* <div className="col">
                                          <p className="h6 p_text_color mb-2">Quote Requests</p>
                                          <div className="div-margin-positive"><small className="p_text_color"></small></div>                  
                                          <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 450, hide: 250 }}
                                                overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                    opacity: 0.4,
                                                  }}>
                                                {labelConfigs.LBL_NEW_QUOTE_REQUESTS}
                                              </Tooltip>}
                                            > 
                                               <span className="h2 mb-0 text-red href-link" onClick={(e) => this.goToClientProfile(e,"new_quote")}>
                                            {quoteRequested.new_requests}
                                            </span>
                                               
                                            </OverlayTrigger>  
                                                            
                                            
                                            <span className="h2 mb-0 text-black"> : </span>

                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 450, hide: 250 }}
                                                overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                    opacity: 0.4,
                                                  }}>
                                                {labelConfigs.LBL_EXISTING_QUOTE_REQUESTS}
                                              </Tooltip>}
                                            > 
                                               <span className="h2 mb-0 text-red href-link" onClick={(e) => this.goToClientProfile(e,"existing_quote")}>{quoteRequested.existing_requests}</span>
                                               
                                            </OverlayTrigger>  

                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info RedViolet"><i className="fas fa-exchange-alt"></i></span>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                            </div>

                            <div className="dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"shift")} >
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-number">
                                            <span className="h2 mb-0 text-red">
                                              {unallocatedShifts}
                                            </span> 
                                        </div>
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div>
                                                {labelConfigs.LBL_UNALLOCATED_SHIFT}
                                                <div><small className="p_text_color">({labelConfigs.LBL_TODAY_TOMORROW})</small></div>
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info BlueRibbon"><i className="fas fa-ban"></i></span>
                                        </div>

                                        {/* <div className="col">                  
                                          <p className="h6 p_text_color mb-2">{labelConfigs.LBL_UNALLOCATED_SHIFT}</p> 
                                           <div className="div-margin-negative"><small className="p_text_color">({labelConfigs.LBL_TODAY_TOMORROW})</small></div>        
                                          <span className="h2 mb-0 text-red">
                                            {unallocatedShifts}
                                          </span> 
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info BlueRibbon"><i className="fas fa-ban"></i></span>
                                        </div> */}
                                    </div>
                                  </div>
                                </div>
                            </div>

                            <div className="dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"crew")}>
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-number">
                                            <span className="h2 mb-0">
                                              {expiringCertificates}
                                            </span> 
                                        </div>
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div>
                                                {labelConfigs.LBL_EXPIRING_CERTIFICATES}
                                                <div><small className="p_text_color">({labelConfigs.LBL_WITHIN_30_DAYS})</small></div>
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info OceanGreen"><i className="fas fa-user-clock"></i></span>
                                        </div>

                                        {/* <div className="col">                   
                                          <p className="h6 p_text_color mb-2">Expiring Certificates</p>                  
                                          <div className="div-margin-negative"><small className="p_text_color">(Within 30 days)</small></div>
                                          <span className="h2 mb-0">
                                            {expiringCertificates}
                                          </span>                 
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info OceanGreen"><i className="fas fa-user-clock"></i></span>
                                      </div>  */}
                                    </div>
                                  </div>                           
                                </div>

                            </div>
                          </div>  

                          <div className="dash-row stories  margin-left-10">
                            <div className="dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"feedback")}>
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-number">
                                            <span className="h2 mb-0">{negativeFeedbacks}</span> 
                                        </div>
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div>
                                                {labelConfigs.LBL_NEGATIVE_FEEDBACK}
                                                <div><small className="p_text_color">({labelConfigs.LBL_LAST_30_DAYS})</small></div>
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info PurpleHeart"><i className="fas fa-comment-slash"></i></span>
                                        </div>

                                        {/* <div className="col">                  
                                          <p className="h6 mb-2 p_text_color">Negative Feedback</p>                  
                                          <div className="div-margin-negative"><small className="p_text_color">(Last 30 days)</small></div>
                                          <span className="h2 mb-0">
                                            {negativeFeedbacks}
                                          </span>                 
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info PurpleHeart"><i className="fas fa-comment-slash"></i></span>
                                        </div> */}
                                    </div>
                                  </div>                           
                                </div>
                            </div>

                            <div className="dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"timesheet")}>
                                    <div className="card-body">
                                      <div className="dash-row align-items-center">
                                        <div className="dash-card-number">
                                            <span className="h2 mb-0">{overTimeRequests}</span> 
                                        </div>
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div>
                                                {labelConfigs.LBL_OVERTIME_REQUESTS}
                                                <div><small className="p_text_color"></small></div>
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol">
                                          <span className="circle-info Mandy"><i className="fas fa-stopwatch"></i></span>
                                        </div>

                                        {/* <div className="col">                  
                                          <p className="h6 mb-2 p_text_color">OT/OE Requests</p>
                                          <div className="div-margin-positive"><small className="p_text_color"></small></div>                  
                                          <span className="h2 mb-0">
                                            {overTimeRequests}
                                          </span>                 
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info Mandy"><i className="fas fa-stopwatch"></i></span>
                                        </div>  */}
                                    </div>
                                  </div>                           
                                </div>
                            </div>

                            <div className="dash-col3">
                                <div className="card spanPointer" onClick={(e) => this.goToClientProfile(e,"shift_time_change")}>
                                    <div className="card-body">
                                      <div className="dash-row">
                                        <div className="dash-card-number">
                                            <span className="h2 mb-0">
                                              {this.state.shiftTimeChangeRequestCount}
                                            </span> 
                                        </div>
                                        <div className="dash-card-text h6 mb-2 p_text_color">{labelConfigs.LBL_SHIFT_TIME_CHANGE_REQUESTS}</div>
                                        <div className="dash-card-symbol"><span className="circle-info Mandy"><i className="fas fa-clock"></i></span></div>
                                        </div>


                                        {/*<div className="dash-row">  
                                        <div className="col">   
                                          <span className="h2 mb-0">
                                              {this.state.shiftTimeChangeRequestCount}
                                            </span>  
                                          </div>    
                                          <div className="col">                   
                                            <div className="h6 mb-2 p_text_color">{labelConfigs.LBL_SHIFT_TIME_CHANGE_REQUESTS}</div>
                                             <div className="div-margin-positive"><small className="p_text_color"></small></div> 
                                        </div>
                                        <div className="dash-col-auto">                  
                                            <span className="circle-info Mandy"><i className="fas fa-clock"></i></span>
                                      </div> 
                                    </div>*/}
                                  </div>                           
                                </div>
                            </div>

                        </div>












                        <div className="dash-row action mt-2">
                            <div className="col-3 col-lg-4">
                                <div className="text-12 div150">&nbsp; &nbsp;<Link to="#" onClick={this.onShowAllUnapprovedCrews}>{labelConfigs.LBL_SHOW_UNAPPROVED_CREW}</Link>{this.props.unapprovedCrewCount>0 && <span className='crew-count'> ({this.props.unapprovedCrewCount})</span>}</div> 
                            </div>
                            <div className={disableDate?"col-3 col-lg-2 mr-0":'hide'}>
                            </div>
                            <div className={disableDate?"col-3 col-lg-2 mr-0":'hide'}>
                            </div>
                            <div className="col-3 col-lg-2 mr-0">
                                <div className="form-group select-input bg-white">
                                    <select className="" aria-placeholder="Select" onChange={e => this.onDateTypeChange(e,'affiliate')}>
                                        <option value="created_date">Created Date</option>
                                        <option value="event_date">{labelConfigs.LBL_EVENT} Date</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-3 col-lg-2 mr-0">
                                <div className="form-group select-input bg-white">
                                    <select className="" aria-placeholder="Select" onChange={e => this.onDaysChange(e,'affiliate')}>
                                        <option value="last_30">Last 30 days</option>
                                        <option value="next_30">Next 30 days</option>
                                        <option value="last_60">Last 60 days</option>
                                        <option value="next_60">Next 60 days</option>
                                        <option value="last_90">Last 90 days</option>
                                        <option value="next_90">Next 90 days</option>
                                        <option value="last_120">Last 120 days</option>
                                        <option value="next_120">Next 120 days</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                            <div className={disableDate?'hide':"col-3 col-lg-2 mr-0"}>
                                <div className="form-group">
                                    <div className={disableDate?'text-optional calendar-input':'calendar-input background-white'}>
                                        <DatePicker 
                                            onChange={selected =>this.onStartDateChange(selected, 'affiliate')}
                                            name="startDate"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Start Date"
                                            fixedHeight          
                                            className={formErrors.startDate ? "input-error" : ''}
                                            disabled={disableDate}
                                            selected={selectedStartDate}
                                            placeHolderTextStyle={{ color: '#d3d3d3' }}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={disableDate?'hide':"col-3 col-lg-2 mr-0"}>
                                <div className="form-group">
                                    <div className={disableDate?'text-optional calendar-input':'calendar-input background-white'}>
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="End Date"
                                                minDate={startDate}
                                                fixedHeight       
                                                disabled={disableDate}
                                                onChange={selected =>this.onEndDateChange(selected,'affiliate')}                       
                                            />
                                    </div>
                                </div>
                            </div>      
                        </div>
                        <div className="dash-row mt-2">
                            <div className="col-6">
                                <div className="dashbox">
                                    <div className="box-head">
                                            <h6 className="m-0 divFloatLeft">Quote Summary</h6>
                                            <p className="h6 text-muted right-align marginBottomO"><Link onMouseDown={e => this.redirectToQuote(e,'affiliate')} to="#">+ New Quote</Link></p>
                                        
                                    </div>
                                        <div className="chart" id={"pieChart"}>
                                          <Chart
                                              width={'100%'}
                                              height={'40vh'}
                                              chartType="PieChart"
                                              loader={<div>Loading Chart</div>}
                                              messages={{empty: "No data"}}
                                              data={quoteRequestData}
                                                options={{
                                                  legend: {
                                                        position: 'right',
                                                        alignment: "top",
                                                        textStyle: {
                                                          color: "233238",
                                                          fontSize: 14
                                                        }
                                                      },
                                                  pieSliceText: 'label',
                                                  title: '',
                                                  pieStartAngle: 100,
                                                  slices: [
                                                            {
                                                              color: "#6b1c68"
                                                            },
                                                            {
                                                              color: "#0e6f69"
                                                            },
                                                            {
                                                              color: "#0895c4"
                                                            },
                                                            {
                                                              color: "#003B5C"
                                                            },
                                                            {
                                                              color: "#d53554"
                                                            },
                                                            {
                                                              color: "#51104e"
                                                            },
                                                            {
                                                              color: "#dc724c"
                                                            }
                                                          ]
                                                }}
                                                rootProps={{ 'data-testid': '4' }}


                                          />
                                        </div>
                                </div>                         
                            </div>
                            <div className="col-6">
                                <div className="dashbox">
                                    <div className="box-head">
                                        <h6 className="m-0">{labelConfigs.LBL_EVENT} Summary</h6>
                                    </div>
                                        <div className="chart" id={"pieChart"}>
                                          <Chart
                                              width={'100%'}
                                              height={'40vh'}
                                              chartType="PieChart"
                                              loader={<div>Loading Chart</div>}
                                              data={activeEventData}
                                                options={{
                                                  pieHole: 0.4,
                                                  legend: {
                                                        position: "right",
                                                        alignment: "top",
                                                        textStyle: {
                                                          color: "233238",
                                                          fontSize: 14
                                                        }
                                                      },
                                                  pieSliceText: 'label',
                                                  title: '',
                                                  pieStartAngle: 100,
                                                  slices: [
                                                            {
                                                              color: "#6b1c68"
                                                            },
                                                            {
                                                              color: "#0e6f69"
                                                            },
                                                            {
                                                              color: "#0895c4"
                                                            },
                                                            {
                                                              color: "#003B5C" 
                                                            },
                                                            {
                                                              color: "#d53554"
                                                            },
                                                            {
                                                              color: "#58b67c"
                                                            },
                                                            {
                                                              color: "#999"
                                                            },
                                                            {
                                                              color: "#dc724c"
                                                            },
                                                            {
                                                              color: "#51104e"
                                                            }
                                                          ]
                                                }}
                                                rootProps={{ 'data-testid': '4' }}


                                          />
                                        </div>                   
                                </div>
                            </div>
                            
                        </div>
                        <div className="dash-row mt-2">
                            <div className="col-12">
                                    <div className="dashbox">
                                        <div className="box-head">
                                            <h6 className="m-0">Shift Summary   ({ startfrom} - {endTo})</h6>
                                        </div>
                                            <div className="chart" id={"barChart"}>
                                                <Chart
                                                    width={'100%'}
                                                  height={'40vh'}
                                                    chartType="ColumnChart"
                                                    loader={<div>Loading Chart</div>}
                                                    data={shiftData}

                                                    options={{
                                                      isStacked: true,
                                                      title: '',
                                                      chartArea: { width: '80%' },
                                                      hAxis: {
                                                        title: 'Shift Date',
                                                        minValue: 1,
                                                        textStyle : {
                                                                fontSize: 14
                                                            }
                                                      },
                                                      vAxis: {
                                                        title: 'Status Count',
                                                      },
                                                      bar: { groupWidth: '50%' },
                                                      legend: {
                                                            position: "top",
                                                            alignment: "top",
                                                            textStyle: {
                                                              color: "233238",
                                                              fontSize: 14
                                                            }
                                                          },
                                                      colors:['#6b1c68',
                                                             '#0e6f69','#0895c4',
                                                             '#003B5C','#d53554',
                                                             '#58b67c','#999',
                                                             '#dc724c',
                                                             '#51104e']
                                                    }}
                                                    // For tests
                                                    rootProps={{ 'data-testid': '1' }}
                                                  />              
                                                </div>
                                    </div>
                                </div>
                            </div>
                          
                    </div>    
                </div> 

            </React.Fragment>    
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        // status:state.changePassword.status,
        // activity:state.changePassword.activity,
        // responseData:state.changePassword.responseData
        fcmNotifiTokenSaveStatus:state.fcmNotifiToken.fcmNotifiTokenSaveStatus,
        fcmNotifiTokenSaveActivity:state.fcmNotifiToken.fcmNotifiTokenSaveActivity,
        fcmNotifiTokenSaveErrorData:state.fcmNotifiToken.fcmNotifiTokenSaveErrorData,
        fcmNotificationSendStatus:state.fcmNotifiToken.fcmNotificationSendStatus,
        fcmNotificationSendActivity:state.fcmNotifiToken.fcmNotificationSendActivity,
        fcmNotificationSendErrorData:state.fcmNotifiToken.fcmNotificationSendErrorData,
        actionRequiredItems:state.actionRequiredItems.actionRequiredItems,
        dashboardChartData:state.actionRequiredItems.dashboardChartData,
        dashboardClientChartData:state.actionRequiredItems.dashboardClientChartData,
        clientActionRequiredItems:state.actionRequiredItems.clientActionRequiredItems,
        activity:state.actionRequiredItems.activity,
        isFilterOn: state.commons.isFilterOn,
        status: state.actionRequiredItems.status,
        shiftTimeChangeRequestCountData: state.actionRequiredItems.shiftTimeChangeRequestCountData,
        unapprovedCrewCount:state.crews.unapprovedCrewCount
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        // changePasswordAction:changePasswordAction,  
        // clearAction:clearAction
        fcmNotifiTokenSaveAction:fcmNotifiTokenSaveAction,
        fcmNotificationSendAction:fcmNotificationSendAction,
        getActionRequiredData:getActionRequiredData,
        getClientActionRequiredData:getClientActionRequiredData,
        clearAction:clearAction,
        chartData:chartData,
        clientChartData:clientChartData,
        fromDashboard:fromDashboard,
        fromClientDashboardQuotes:fromClientDashboardQuotes,
        fromClientDashboardEvents:fromClientDashboardEvents,
        fromClientDashboardCompletedEvents:fromClientDashboardCompletedEvents,
        fromActionRequired:fromActionRequired,
        shiftTimeChangeRequestCountAction:shiftTimeChangeRequestCountAction,
        fromDashboardShiftTimeChange:fromDashboardShiftTimeChange,
        crewUnapprovedCountAction:crewUnapprovedCountAction,
        
    },dispatch);
}               

export default connect(mapStateToProps,mapDispatchToProps)(DashBoardComponent);

